const props = {
  MuiCard: {
    elevation: 0,
    style: {
      borderRadius: 0,
      border: "1px solid",
      borderColor: "rgba(204, 204, 204)",
    },
  },
  MuiButtonBase: {
    disableRipple: true,
  },
  MuiCard: {
    elevation: 0,
  },
  MuiCardHeader: {
    titleTypographyProps: { variant: "h6" },
  },
};

export default props;
